import { Component } from '@angular/core';

@Component({
  selector: 'app-home-carousel-styles',
  imports: [],
  templateUrl: './home-carousel-styles.html',
  styleUrl: './home-carousel-styles.scss'
})
export class HomeCarouselStyles {

}
